export default {
  name: "useInstruction",
  data: function data() {
    return {
      showMore: true
    };
  },
  props: ["couponDetail", "isTicket", "isEntranceTicket", "isMultipleDetails", "isReviewing", "promoterGroup"],
  computed: {},
  watch: {
    couponDetail: {
      immediate: true,
      // 初始化时也执行一次
      handler: function handler(newVal) {
        var _this = this;
        this.$nextTick(function () {
          if (_this.$refs.useInstruction) {
            var height = _this.$refs.useInstruction.offsetHeight || 0;
            if (height > 148) {
              _this.showMore = false;
            } else {
              _this.showMore = true;
            }
          }
        });
      }
    }
  },
  methods: {
    expandAll: function expandAll() {
      this.showMore = true;
    }
  }
};